/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAppointmentProps, toScheduleRequest } from './translator/appointment'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchSchedule, PostSchedule, GetSchedule, PutSchedule, DeleteSchedule } from '@/infrastructure/network/Monitaro/requests/schedule'
import { IAppointmentProps } from '@/entities/Appointment'

export default class Schedule extends MonitaroGatewayBase {
  async FetchSchedule(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchSchedule(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.appointments.map((prop) => toAppointmentProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostSchedule(params: IAppointmentProps) {
    const { appointment } = await this.apiClient.request(new PostSchedule(toScheduleRequest(params)))
    return toAppointmentProps(appointment)
  }

  async GetSchedule(id: string) {
    const { appointment } = await this.apiClient.request(new GetSchedule(id))
    return toAppointmentProps(appointment)
  }

  async PutSchedule(id: string, params: IAppointmentProps) {
    const { appointment } = await this.apiClient.request(new PutSchedule(id, toScheduleRequest(params)))
    return toAppointmentProps(appointment)
  }

  async DeleteSchedule(id: string, target?: 'result' | 'schedule') {
    const response = await this.apiClient.request(new DeleteSchedule(id, target))
    return response
  }
}
